<plc-icon [name]="icon" [color]="'white'" />

<p class="plc-disclaimer__text" [innerHtml]="text | plcMarkdown"></p>
